import { useSignatures } from "../../../../hooks/useSignatures";
import { useWorkorderContext } from "../../../../context/WorkorderContext";
import SignatureCard from "./SignatureCard";

interface SignaturesSectionProps {
  workorderId: string;
  initialSignatures: EasyTech.Photo[];
  contacts: EasyTech.Contact[];
  canEdit?: boolean;
}

export default function SignaturesSection({
  workorderId,
  initialSignatures,
  contacts,
  canEdit = true
}: SignaturesSectionProps) {
  const { workorder, updateWorkorder } = useWorkorderContext();
  const {
    signatures,
    deleteSignature,
    setSignatures,
    getDownloadUrl
  } = useSignatures({
    workorderId,
    initialSignatures,
  });

  return (
    <div className="flex justify-between gap-4">
      <SignatureCard
        type="AFTER"
        workorderId={workorderId}
        contacts={contacts}
        canEdit={canEdit}
        workorder={workorder}
        updateWorkorder={updateWorkorder}
        signatures={signatures as EasyTech.Photo[]}
        setSignatures={setSignatures as (fn: (prev: EasyTech.Photo[]) => EasyTech.Photo[]) => void}
        deleteSignature={deleteSignature}
        getDownloadUrl={getDownloadUrl}
      />
    </div>
  );
} 